import { render } from "./Time.vue?vue&type=template&id=7708eeb8&lang=pug"
import script from "./Time.vue?vue&type=script&lang=ts"
export * from "./Time.vue?vue&type=script&lang=ts"
script.render = render

export default script